import { motion } from 'framer-motion/dist/framer-motion';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { flexGap } from 'untils/polyfill/flex';
import { vw } from 'components/common/Common';

const Blog = styled(motion.div)`
  --card-min-width: 279px;

  min-width: var(--card-min-width);
  width: calc((100vw - var(--home-section-padding) - ${vw(64)}) / 3);
  max-width: 376px;
  height: 100%;
  //! for border-radius to work
  overflow: hidden;
  padding: 16px;

  @media (max-width: 757px) {
    width: var(--card-min-width);
  }
`;

const BlogLink = styled(Link)`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  line-height: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 757px) {
    min-width: var(--card-min-width);
    height: 224px;
    & > img {
      filter: brightness(0.6);
      position: absolute;
      height: 149px;
    }
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${flexGap('16px')}
`;

const CardImg = styled.img`
  border-radius: 4px;
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const Title = styled.h3`
  font-weight: 500;
  font-size: 24px;
  margin: 0;
  color: #050a30;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Desc = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #424748;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Date = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #424748;
`;

const variant = {
  hover: {
    y: -8,
    boxShadow: '0px 4px 16px rgba(77, 100, 126, 0.4)',
    transition: { duration: 0.5 },
  },
};

const BlogLinkComponent = forwardRef((props, ref) => <BlogLink ref={ref} {...props} />);
BlogLinkComponent.displayName = 'BlogLinkComponent';
const MotionLinkComponent = motion(BlogLinkComponent);

const Card = ({ item }) => {
  return (
    <Blog variants={variant} whileHover="hover">
      <MotionLinkComponent
        to={{
          pathname: item.path,
          state: item,
        }}
      >
        <Info>
          <CardImg src={item.picture} alt={item.altImage} />
          <Title>{item.info.title}</Title>
          <Desc>{item.info.describe}</Desc>
        </Info>
        <Date>{dayjs(item.info.date, 'YYYY-MM-DD').format('MMM DD, YYYY')}</Date>
      </MotionLinkComponent>
    </Blog>
  );
};

export default Card;
